// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VnH4","label":"styles_label__bcItN"};